export const BUSINESS = {
  name: "CLEM by Cerón",
  city: "Armenia, Quindío, Colombia",
  whatsappDisplay: "+57 333-278-2723",
  address: "Cra. 16 #21 NORTE-21, Armenia, Quindío",
  hours:
    "Lunes a jueves: 12:30 pm a 4:00 pm y 6:00 pm a 9:00 pm · Viernes y sábado: 12:30 pm a 4:00 pm y 6:00 pm a 10:00 pm · Domingos: sin servicio",
  slogan:
    "Hay recetas que no están escritas. Están en la memoria, en las manos, en el olor de una cocina de antes y de ahora.",
};

export const WA_LINKS = {
  reservar:
    "https://wa.me/573332782723?text=Hola%20CLEM%2C%20quisiera%20reservar%20una%20mesa",
  info: "https://wa.me/573332782723?text=Hola%20CLEM%2C%20quisiera%20m%C3%A1s%20informaci%C3%B3n",
  carta:
    "https://wa.me/573332782723?text=Hola%20CLEM%2C%20quisiera%20ver%20la%20carta",
};

export const LINKS = {
  menu: "https://menu.clembyceron.com/",
  maps: "https://maps.app.goo.gl/skUQ7c6Yj6kUAKm36",
  mapsEmbed:
    "https://www.google.com/maps?q=CLEM+by+Cer%C3%B3n+Armenia+Quind%C3%ADo&output=embed",
  instagramClem: "https://www.instagram.com/clembyceron/",
  instagramSando: "https://www.instagram.com/sandobyceron/",
};

export const NAV_ITEMS = [
  { id: "inicio", label: "Inicio" },
  { id: "recomendados", label: "Recomendados" },
  { id: "nosotros", label: "Nosotros" },
  { id: "ubicacion", label: "Cómo llegar" },
  { id: "contacto", label: "Contacto" },
];